module.exports = __webpack_public_path__ + "img/2.3bf7931.jpg";